import { Component } from '@angular/core';
import { UtilidadesService } from './utilidades/utilidades.servicios.index';

@Component({
	selector: 'app-root',
	templateUrl: "./app.component.html",
	styles: []
})
export class AppComponent {

	constructor(
		public Utilidades: UtilidadesService
	) {
		
	}

	onActivate(event) {
		window.scroll(0,0);
	}

}